// Module
var code = "<div class=\"grid-stack-item-content\"> <div class=\"grid-stack-item-content-inner\"> <div class=\"dashboard-widget-empty-hint\" ng-click=\"$ctrl.changeToEditMode()\"> <div class=\"dashboard-widget-empty-hint__inner\"> <atom-text> <span translate=\"TR_110621-87909f_TR\"></span> </atom-text> </div> </div> </div> </div> ";
// Exports
module.exports = code;